import { memo } from 'react';

import RequestedFormCompletionItem from '@/components/RequestedFormCompletionItem';

import type { Props } from './types';

const RequestedFormCompletionList = ({ requestedFormCompletions }: Props) => {
  return (
    <ul className="space-y-4">
      {requestedFormCompletions.map((requestedFormCompletion) => {
        return (
          <li key={requestedFormCompletion.id}>
            <RequestedFormCompletionItem requestedFormCompletion={requestedFormCompletion} />
          </li>
        );
      })}
    </ul>
  );
};
export default memo(RequestedFormCompletionList);
